import React, {Component} from 'react'
import {Circle} from 'react-konva'
import {KonvaEventObject} from 'konva/lib/Node'
import {CircleElement as CircleElementData} from '../../../views/LabelBuilder/LabelBuilder.slice'

interface Props {
    element: CircleElementData
    onClick: (event: KonvaEventObject<MouseEvent>) => void
    onTransform: (event: KonvaEventObject<MouseEvent>) => void
    onDrag: (event: KonvaEventObject<DragEvent>) => void
    onRightClick: (event: KonvaEventObject<PointerEvent>) => void
    draggable?: boolean
}

export default class CircleElement extends Component<Props> {
    render() {
        const {element, draggable = true} = this.props
        return (
            <Circle
                opacity={element.opacity}
                radius={element.radius}
                fill={element.fill}
                strokeWidth={element.strokeWidth}
                id={element.id}
                key={element.id}
                draggable={draggable}
                stroke={element.stroke}
                strokeScaleEnabled={false}
                x={element.x}
                y={element.y}
                scaleX={element.scaleX}
                scaleY={element.scaleY}
                rotation={element.rotation}
                onClick={this.props.onClick}
                onTransform={this.props.onTransform}
                onDragEnd={this.props.onDrag}
                onContextMenu={this.props.onRightClick}/>
        )
    }
}
